<template>
  <v-container fluid grid-list-xl>
    <v-layout wrap>
      <v-flex
        sm4
        xs12
        class="text-sm-left text-xs-center"
      >
        <v-btn @click="previous">
          <v-icon
            dark
            left
          >
            keyboard_arrow_left
          </v-icon>
          Prev
        </v-btn>
      </v-flex>

      <v-flex
        sm4
        xs12
        class="text-xs-center"
      >
        <v-select
          v-model="type"
          :items="typeOptions"
          label="Type"
        ></v-select>
      </v-flex>

      <v-flex
        sm4
        xs12
        class="text-sm-right text-xs-center"
      >
        <v-btn @click="next">
          Next
          <v-icon
            right
            dark
          >
            keyboard_arrow_right
          </v-icon>
        </v-btn>
      </v-flex>

      <v-flex
        xs12
        class="mb-3"
      >
        <v-calendar
          color="primary"
          ref="calendar"
          :type="type"
          v-model="today"
          interval-count="0"
          @click:date="test"
          @change="updateRange"
        >

          <!-- Week/day will show events as all day in the header -->
          <template v-slot:dayHeader="{ date }">
            <template v-if="type==='day'">
              <v-layout row wrap>
                  <v-flex v-for="(event) in rows[date]" xs4 :key="event.id">
                    <v-card>
                      <v-toolbar
                        color="primary"
                        dark
                        dense
                      >
                        <v-toolbar-title>
                          {{ event.card_name }}
                          <span v-if="event.customer_po">({{ event.customer_po }})</span>
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-layout column pa-2>
                          <v-flex class="text-capitalize" pa-1>{{ event.recurring_type }}</v-flex>
                          <v-flex v-if="event.payment_type==='ach'" pa-1>{{ event.payment_type }}</v-flex>
                          <v-flex v-else pa-1><img :src="'/static/cards/' + event.payment_type + '.svg'" height="24px" /></v-flex>
                          <v-flex class="text-capitalize" pa-1>{{ event.transaction_status }}</v-flex>
                          <v-flex pa-1>{{ money(event.total_amount) }}</v-flex>
                          <v-flex pa-1>{{ event.last_four }}</v-flex>
                          <v-flex v-if="event.card_expiration_yymm" pa-1>{{ expiration(event.card_expiration_yymm) }}</v-flex>
                          <v-flex v-if="event.custom_field_1" class="text-wrap" pa-1>{{ event.custom_field_1 }}</v-flex>
                          <v-flex v-if="event.custom_field_2" class="text-wrap" pa-1>{{ event.custom_field_1 }}</v-flex>
                          <v-flex v-if="event.custom_field_3" class="text-wrap" pa-1>{{ event.custom_field_1 }}</v-flex>
                          <v-flex v-if="event.notes" class="text-wrap" pa-1>{{ event.notes }}</v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <OptionsModal :transaction="event" :ref="'options-' + event.tracking_id" :round="false"></OptionsModal>
                        <v-btn
                          v-if="event.transaction_group_custom_tracking_id"
                          :to="{ name: 'PlanManage', query: { id: event.transaction_group_custom_tracking_id }}"
                          small
                        >
                          Payment Plan
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
              </v-layout>
            </template>

              <v-menu
                v-if="type==='week'" v-for="(event) in rows[date]"
                :key="event.id"
                v-model="event.open"
                full-width
                offset-x
              >

                <template v-slot:activator="{ on }">
                  <div
                    v-ripple
                    class="event"
                    v-on="on"
                  >
                    {{ event.card_name }}
                    <span v-if="event.customer_po">({{ event.customer_po }})</span>
                  </div>
                </template>

                <v-card
                  color="grey lighten-4"
                  min-width="350px"
                  flat
                >
                  <v-toolbar
                    color="primary"
                    dark
                    dense
                  >
                    <v-toolbar-title>
                      {{ event.card_name }}
                      <span v-if="event.customer_po">({{ event.customer_po }})</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon flat>
                      <v-icon>fa-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout column>
                      <v-flex class="text-capitalize">{{ event.recurring_type }}</v-flex>
                      <v-flex v-if="event.payment_type==='ach'">{{ event.payment_type }}</v-flex>
                      <v-flex v-else><img :src="'/static/cards/' + event.payment_type + '.svg'" height="24px" /></v-flex>
                      <v-flex class="text-capitalize">{{ event.transaction_status }}</v-flex>
                      <v-flex>{{ money(event.total_amount) }}</v-flex>
                      <v-flex>{{ event.last_four }}</v-flex>
                      <v-flex v-if="event.card_expiration_yymm">{{ expiration(event.card_expiration_yymm) }}</v-flex>
                      <v-flex v-if="event.custom_field_1" class="text-wrap">{{ event.custom_field_1 }}</v-flex>
                      <v-flex v-if="event.custom_field_2" class="text-wrap">{{ event.custom_field_1 }}</v-flex>
                      <v-flex v-if="event.custom_field_3" class="text-wrap">{{ event.custom_field_1 }}</v-flex>
                      <v-flex v-if="event.notes" class="text-wrap">{{ event.notes }}</v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <OptionsModal :transaction="event" :ref="'options-' + event.tracking_id" :round="false"></OptionsModal>
                    <v-btn
                      v-if="event.transaction_group_custom_tracking_id"
                      :to="{ name: 'PlanManage', query: { id: event.transaction_group_custom_tracking_id }}"
                      small
                    >
                      Payment Plan
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
          </template>

          <!-- Monthly view -->
          <template v-slot:day="{ date }">
            <template v-for="(event, index) in rows[date]">
              <div
                class="event more"
                :key="event.id"
                @click="today=date; type='day'"
                v-if="index === 3"
                v-ripple
              >
                {{ rows[date].length - 3 }} More...
              </div>

              <v-menu
                :key="event.id"
                v-model="event.open"
                v-if="index <= 2"
                full-width
                offset-x
              >

                <template v-slot:activator="{ on }">
                  <div
                    v-ripple
                    class="event"
                    v-on="on"
                  >
                    {{ event.card_name }}
                    <span v-if="event.customer_po">({{ event.customer_po }})</span>
                  </div>
                </template>

                <v-card
                  color="grey lighten-4"
                  min-width="350px"
                  flat
                >
                  <v-toolbar
                    color="primary"
                    dark
                    dense
                  >
                    <v-toolbar-title>
                      {{ event.card_name }}
                      <span v-if="event.customer_po">({{ event.customer_po }})</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon flat>
                      <v-icon>fa-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout column>
                      <v-flex class="text-capitalize">{{ event.recurring_type }}</v-flex>
                      <v-flex v-if="event.payment_type==='ach'">{{ event.payment_type }}</v-flex>
                      <v-flex v-else><img :src="'/static/cards/' + event.payment_type + '.svg'" height="24px" /></v-flex>
                      <v-flex class="text-capitalize">{{ event.transaction_status }}</v-flex>
                      <v-flex>{{ money(event.total_amount) }}</v-flex>
                      <v-flex>{{ event.last_four }}</v-flex>
                      <v-flex v-if="event.card_expiration_yymm">{{ expiration(event.card_expiration_yymm) }}</v-flex>
                      <v-flex v-if="event.custom_field_1" class="text-wrap">{{ event.custom_field_1 }}</v-flex>
                      <v-flex v-if="event.custom_field_2" class="text-wrap">{{ event.custom_field_1 }}</v-flex>
                      <v-flex v-if="event.custom_field_3" class="text-wrap">{{ event.custom_field_1 }}</v-flex>
                      <v-flex v-if="event.notes" class="text-wrap">{{ event.notes }}</v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <OptionsModal :transaction="event" :ref="'options-' + event.tracking_id" :round="false"></OptionsModal>
                    <v-btn
                      v-if="event.transaction_group_custom_tracking_id"
                      :to="{ name: 'PlanManage', query: { id: event.transaction_group_custom_tracking_id }}"
                      small
                    >
                      Payment Plan
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>
          </template>
        </v-calendar>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="searchModal = true">Search</v-btn>
    </v-layout>

    <v-dialog v-model="searchModal" @submit.prevent @keydown.esc.prevent="searchModal=false">
      <v-toolbar dense>
        <v-toolbar-title>Search</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="primary" @click.native="searchModal = false">
          <v-icon>fa-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-card-text>
          <v-form @keyup.native.enter="search">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Customer Name"
                    v-model="filter.customer_name"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Last Four"
                    v-model="filter.last_four"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Amount"
                    v-model="filter.amount"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Transaction ID"
                    v-model="filter.tracking_id"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3>
                  <v-menu
                    ref="startDateModal"
                    :close-on-content-click="false"
                    v-model="startDateModal"
                    :nudge-right="40"
                    :return-value.sync="filter.start_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedStartDate"
                      label="Created Start"
                      append-icon="event"
                      box
                      hide-details
                    />
                    <v-date-picker
                      v-model="filter.start_date"
                      no-title
                      @input="$refs.startDateModal.save(filter.start_date)"
                    />
                  </v-menu>
                  <v-menu
                    ref="endDateModal"
                    :close-on-content-click="false"
                    v-model="endDateModal"
                    :nudge-right="40"
                    :return-value.sync="filter.end_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedEndDate"
                      label="Created End"
                      append-icon="event"
                      box
                      hide-details
                    />
                    <v-date-picker
                      v-model="filter.end_date"
                      no-title
                      @input="$refs.endDateModal.save(filter.end_date)"
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Customer PO"
                    v-model="filter.customer_po"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Custom 1"
                    v-model="filter.custom_field_1"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Custom 2"
                    v-model="filter.custom_field_2"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Custom 3"
                    v-model="filter.custom_field_3"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Notes"
                    v-model="filter.notes"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs6 sm3 v-if="paymentType === 'ach' && terminalsACH.length > 1">
                  <v-autocomplete
                    name="terminal"
                    label="Terminal"
                    v-model="filter.terminal_id"
                    :items="terminals"
                    item-text="name"
                    item-value="terminal_id"
                    box
                    hide-details
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 sm3 v-if="paymentType !== 'ach' && terminalsCard.length > 1">
                  <v-autocomplete
                    name="terminal"
                    label="Terminal"
                    v-model="filter.terminal_id"
                    :items="terminals"
                    item-text="name"
                    item-value="terminal_id"
                    box
                    hide-details
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 sm3>
                  <AccountSelect
                    v-model="filter.account_id"
                    multiple
                    label="Account"
                    box
                    hide-details
                    v-if="hasPermission('superuser') || myProfile.accounts.length > 1"
                  />
                </v-flex>
              </v-layout>

              <v-divider class="primary" />

              <v-layout row wrap>
                <v-spacer/>
                <v-flex xs4>
                  <v-layout row wrap justify-end>
                    <v-btn color="primary" @click="search">Search</v-btn>
                    <v-btn @click="reset">Clear</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'

import OptionsModal from '@/components/transactions/OptionsModal.vue'
import AccountSelect from '@/components/common/AccountSelect.vue'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  components: { OptionsModal, AccountSelect },

  mixins: [
    ApiMixin,
    AuthMixin,
    DisplayMixin,
    StoreMixin
  ],

  data: function () {
    return {
      typeOptions: [
        { text: 'Month', value: 'month' },
        { text: 'Week', value: 'week' },
        { text: 'Day', value: 'day' }
      ],
      type: 'month',

      rows: [],
      loading: true,

      // transaction: {},

      today: Moment().format('YYYY-MM-DD'),
      start: '',
      end: '',
      value: '',
      searchModal: false,
      startDateModal: false,
      endDateModal: false,

      filter: this.defaultFilter()
    }
  },

  mounted () {
    this.search()
  },

  destroyed () {
    this.$store.commit('clearErrors')
    this.$store.commit('clearInfo')
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    },

    terminals: function () {
      let terminals = [
        {terminal_id: '*', name: 'All'}
      ]
      if (this.paymentType === 'ach') {
        return terminals.concat(this.terminalsACH)
      } else {
        return terminals.concat(this.terminalsCard)
      }
    },

    formattedStartDate () {
      return this.filter.start_date ? Moment(this.filter.start_date).format('MMM-DD-YYYY') : ''
    },
    formattedEndDate () {
      return this.filter.end_date ? Moment(this.filter.end_date).format('MMM-DD-YYYY') : ''
    }
  },

  methods: {
    defaultFilter () {
      return {
        account_id: [],
        amount: '',
        customer_name: '',
        start_date: Moment().startOf('month').format('YYYY-MM-DD'),
        end_date: Moment().endOf('month').format('YYYY-MM-DD'),
        is_recurring: '*',
        last_four: '',
        terminal_id: '*',
        transaction_id: '',
        tracking_id: '',
        customer_po: '',
        custom_field_1: '',
        custom_field_2: '',
        custom_field_3: '',
        notes: ''
      }
    },

    async search () {
      this.loading = true
      Bus.$emit('openWaitModal')

      try {
        let filter = { ...this.filter }

        if (filter.start_date) {
          filter.start_date = Moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss')
        }
        if (filter.end_date) {
          filter.end_date = Moment(Moment(this.filter.end_date).format('YYYY-MM-DD') + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss')
        }

        let result = await this.api({
          method: 'get',
          url: '/transactions/events',
          params: {
            filter: filter,
            perPage: 25 // @TODO Remove limit and restrict by date range, possible * for day, 10 for week, 4 for month
          }
        })
        this.rows = result.data.rows.data
      } catch (err) {
        if (err.response && err.response.status === 401) {
          this.$store.commit('error', new Error('Token no longer valid, please login again'))
        } else {
          Bus.$emit('openModal', {
            status: 'error',
            message: err
          })
        }
      } finally {
        this.searchModal = false
        this.loading = false
        Bus.$emit('closeWaitModal')
      }
    },

    reset () {
      this.filter = this.defaultFilter()

      this.search()
    },

    test (data) {
      if (this.type !== 'day') {
        this.type = 'day'
      }
    },

    next () {
      this.$refs.calendar.next()
    },

    previous () {
      this.$refs.calendar.prev()
    },

    updateRange (data) {
      this.filter.start_date = data.start.date
      this.filter.end_date = data.end.date
      this.search()
    }

  }
}
</script>

<style lang="less">
  .v-calendar-daily_head-day {
    padding: 4px;
  }
  .event {
    background-color: var(--v-primary-lighten1);
    border: 1px solid var(--v-primary-base);
    border-radius: 2px;
    color: #ffffff;
    cursor: pointer;
    font-size: 12px;
    margin-bottom: 1px;
    overflow: hidden;
    padding: 3px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .more {
    background-color: var(--v-primary-base);
    border: 1px solid var(--v-primary-lighten1);
  }
</style>



// WEBPACK FOOTER //
// src/components/transactions/Calendar.vue